//function that highlights active filter or menu element
$(function() {
  	if($('#tags-btn').attr('aria-expanded') == 'true'){
       	$('.collections-menu').css("max-height", '50rem');
    } else if($('#tags-btn').attr('aria-expanded') == 'false' && $(window).width() < 426){
     	$('.collections-menu').css("max-height", '14.5rem');
    }
    var currentLocation = window.location.pathname;
    var currentType = currentLocation.substring(currentLocation.lastIndexOf('/') + 1);
    $('.current-type').removeClass('current-type');
    
  	//toggles wishlist buttons if the user has any products added to wishlist from earlier
    $('.iwishAdded').parent().css("display", "none");
    $('.iwishAdded').parent().next().css("display","flex");
    
    if ($("a[href='" + currentLocation + "']").length > 1){
    
        $("a[href='" + currentLocation + "']").eq(0).addClass('current-type'); //desktop menu
        $("a[href='" + currentLocation + "']").eq(1).addClass('current-type'); //mobile menu
        $("a[href='" + currentLocation + "']").eq(2).addClass('current-type'); //filter
    } else {
        $("a[href='" + currentLocation + "']").addClass('current-type');
    }
});

$(function() {
    $('#tags-btn').on('click', function(){
        if($('#tags-btn').attr('aria-expanded') == 'false'){
            $('.collections-menu').animate({maxHeight: '50rem'}, 250);
        }else if($('#tags-btn').attr('aria-expanded') == 'true' && $(window).width() > 426){
            $('.collections-menu').animate({maxHeight: '20.5rem'}, 250);
        }else {
            $('.collections-menu').animate({maxHeight: '14.5rem'}, 250);
        }
    });
});

//function that toggles the wishlist buttons
$(function() {
  	$('.iwishAddBtn').on('click', function(){
      iwish_addCollection($(this), $(this).attr('data-variant'));
      $(this).parent().css("display","none");
      $(this).parent().next().css("display","flex");
      $(this).removeClass('iwishAdded');
    });

    $('.iwishRemoveBtn').on('click', function(e){
      e.preventDefault();
        iwish_remove($(this), $(this).attr('data-variant'), $(this).attr('data-ptitle'));
      $(this).parent().css("display","none");
      $(this).addClass('iwishRemoved');
      $(this).parent().prev().children().removeClass('iwishAdded');
      $(this).parent().prev().children().children().removeClass('fa-heart');
      $(this).parent().prev().children().children().addClass('fa-heart-o');
      $(this).parent().prev().css("display","flex");
    });
});